export var DOBApplets;
(function (DOBApplets) {
    DOBApplets["APP"] = "app";
    DOBApplets["NFT"] = "nft";
    DOBApplets["BAZAAR"] = "bazaar";
    DOBApplets["EXPLORER"] = "explorer";
    DOBApplets["PRO"] = "pro";
})(DOBApplets || (DOBApplets = {}));
export var ChainId;
(function (ChainId) {
    ChainId[ChainId["ETH_MAINNET"] = 1] = "ETH_MAINNET";
    ChainId[ChainId["ETH_SEPOLIA"] = 11155111] = "ETH_SEPOLIA";
    ChainId[ChainId["SCROLL_SEPOLIA"] = 534351] = "SCROLL_SEPOLIA";
    // SCROLL = 534352,
})(ChainId || (ChainId = {}));
export var ChainEnvironment;
(function (ChainEnvironment) {
    ChainEnvironment["PROD"] = "MAINNET";
    ChainEnvironment["TEST"] = "TESTNET";
})(ChainEnvironment || (ChainEnvironment = {}));
export var ChainName;
(function (ChainName) {
    ChainName["ETH_MAINNET"] = "Ethereum";
    ChainName["ETH_SEPOLIA"] = "Sepolia";
    ChainName["SCROLL_SEPOLIA"] = "Scroll Sepolia";
})(ChainName || (ChainName = {}));
export var Networkish;
(function (Networkish) {
    Networkish["ETH_MAINNET"] = "homestead";
    Networkish["ETH_SEPOLIA"] = "sepolia";
    Networkish["SCROLL_SEPOLIA"] = "scroll-sepolia";
})(Networkish || (Networkish = {}));
export var RPCProvider;
(function (RPCProvider) {
    RPCProvider["ALCHEMY"] = "alchemy";
    RPCProvider["QUICKNODE"] = "quicknode";
    RPCProvider["JSON_RPC"] = "json-rpc";
})(RPCProvider || (RPCProvider = {}));
export const getRPC = (chainId, provider, apikey = '') => {
    const rpcs = {
        [ChainId.ETH_MAINNET]: {
            [RPCProvider.ALCHEMY]: `https://eth-mainnet.g.alchemy.com/v2/${apikey}`,
            [RPCProvider.QUICKNODE]: '',
            [RPCProvider.JSON_RPC]: '',
        },
        [ChainId.ETH_SEPOLIA]: {
            [RPCProvider.ALCHEMY]: `https://eth-sepolia.g.alchemy.com/v2/${apikey}`,
            [RPCProvider.QUICKNODE]: '',
            [RPCProvider.JSON_RPC]: '',
        },
        [ChainId.SCROLL_SEPOLIA]: {
            [RPCProvider.ALCHEMY]: '',
            [RPCProvider.QUICKNODE]: '',
            [RPCProvider.JSON_RPC]: `https://sepolia-rpc.scroll.io`,
        },
    };
    return rpcs[chainId][provider];
};
export const SUPPORTED_CHAINS = [
    {
        id: ChainId.ETH_MAINNET,
        environment: ChainEnvironment.PROD,
        name: ChainName.ETH_MAINNET,
        networkish: Networkish.ETH_MAINNET,
        isActive: true,
    },
    {
        id: ChainId.ETH_SEPOLIA,
        environment: ChainEnvironment.TEST,
        name: ChainName.ETH_SEPOLIA,
        networkish: Networkish.ETH_SEPOLIA,
        isActive: true,
    },
    {
        id: ChainId.SCROLL_SEPOLIA,
        environment: ChainEnvironment.TEST,
        name: ChainName.SCROLL_SEPOLIA,
        networkish: Networkish.ETH_SEPOLIA,
        isActive: true,
    },
];
export const ID_TO_CHAIN_ID = (id) => {
    switch (id.toString()) {
        case '1':
            return ChainId.ETH_MAINNET;
        case '11155111':
            return ChainId.ETH_SEPOLIA;
        case '534351':
            return ChainId.SCROLL_SEPOLIA;
        default:
            throw new Error(`Unsupported chain id: ${id}`);
    }
};
export const ID_TO_CHAIN_NAME = (id) => {
    switch (id) {
        case ChainId.ETH_MAINNET:
            return ChainName.ETH_MAINNET;
        case ChainId.ETH_SEPOLIA:
            return ChainName.ETH_SEPOLIA;
        case ChainId.SCROLL_SEPOLIA:
            return ChainName.SCROLL_SEPOLIA;
        default:
            throw new Error(`Unsupported chain id: ${id}`);
    }
};
export const CHAIN_ID_TO_NETWORKISH = (id) => {
    switch (id) {
        case ChainId.ETH_MAINNET:
            return Networkish.ETH_MAINNET;
        case ChainId.ETH_SEPOLIA:
            return Networkish.ETH_SEPOLIA;
        case ChainId.SCROLL_SEPOLIA:
            return Networkish.SCROLL_SEPOLIA;
        default:
            throw new Error(`Unsupported chain id: ${id}`);
    }
};
export const NETWORKISH_TO_CHAIN_ID = (id) => {
    switch (id) {
        case Networkish.ETH_MAINNET:
            return ChainId.ETH_MAINNET;
        case Networkish.ETH_SEPOLIA:
            return ChainId.ETH_SEPOLIA;
        case Networkish.SCROLL_SEPOLIA:
            return ChainId.SCROLL_SEPOLIA;
        default:
            throw new Error(`Unsupported chain id: ${id}`);
    }
};
/**
 * Checks if the given network or chain ID is supported.
 *
 * @param {Networkish | ChainId} network - The network or chain ID to check. Can be a string (like network name) or a number (like chain ID).
 * @returns {boolean} Returns true if the given network or chain ID is supported; otherwise, returns false.
 */
export const checkChainSupport = (network) => {
    try {
        const isValidChainId = Number.isNaN(Number(network))
            ? SUPPORTED_CHAINS.some((chain) => chain.networkish === network)
            : SUPPORTED_CHAINS.some((chain) => chain.id === Number(network));
        return isValidChainId;
    }
    catch (_error) {
        return false;
    }
};
//# sourceMappingURL=chains.js.map